import * as React from "react";
import HomeIcon from "@mui/icons-material/Home";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import WifiIcon from "@mui/icons-material/Wifi";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import { Page, FloatingHead } from "./interfaces";

export const PAGES_LIST: Page[] = [
  {
    id: 1,
    name: "Home",
    disabled: false,
    icon: HomeOutlinedIcon,
    selectedIcon: HomeIcon,
    toURL: "/",
    floatingHead: {
      displayText: "Noise",
      displayIcon: <WifiIcon />,
    } as FloatingHead,
  },
  {
    id: 2,
    name: "Blogs",
    disabled: true,
    toURL: "/blogs",
    icon: BorderColorOutlinedIcon,
    selectedIcon: BorderColorIcon,
  },
];

export const SUPPORTED_INDEXES: string[] = [
  "Bank Nifty",
  "Nifty 50",
  "Midcap Nifty",
  "Fin Nifty",
];

export const DEFAULT_POST_PAGE_SIZE: number = 25;
export const DEFAULT_COMMENT_PAGE_SIZE: number = 10;
export const DEFAULT_NEWS_PAGE_SIZE: number = 5;
export const MOBILE_NEWS_PAGE_SIZE: number = 10;

export const DEFAULT_POST_CONTENT_CHAR_LIMIT: number = 561;
export const DEFAULT_COMMENT_CHAR_LIMIT: number = 221;
export const DEFAULT_COMMENT_TEXT_AREA_HEIGHT_PX: number = 120;

export const ID_TYPES: Record<string, string> = {
  post: "post-by-traders-forum",
};

export const DEFAULT_POST_TYPE_MAP: Record<string, string[]> = {
  normal: ["Normal", "Quote"],
  trade: ["Trade"],
};

export const USER_TYPES: Record<string, string> = {
  amateur: "Amateur",
  professional: "Professional",
  beginner: "Beginner",
};
